/**
 * Target Lists API helpers - thin wrappers around apiClient.
 * Keeps all /api/target-lists URLs in one place.
 */
import { apiClient } from "../../utils/api";

export const targetListsApi = {
  list: (status) => apiClient.get("/target-lists", { params: status ? { status } : {} }),
  create: (payload) => apiClient.post("/target-lists", payload),
  get: (id) => apiClient.get(`/target-lists/${id}`),
  update: (id, payload) => apiClient.patch(`/target-lists/${id}`, payload),
  remove: (id) => apiClient.delete(`/target-lists/${id}`),

  leaderboard: (id, range = "week") =>
    apiClient.get(`/target-lists/${id}/leaderboard`, { params: { range } }),

  members: (id, page = 1, pageSize = 50, filters = {}) =>
    apiClient.get(`/target-lists/${id}/members`, {
      params: { page, page_size: pageSize, ...filters },
    }),
  addMembers: (id, companyIds) =>
    apiClient.post(`/target-lists/${id}/members`, { company_ids: companyIds }),
  removeMember: (id, companyId) =>
    apiClient.delete(`/target-lists/${id}/members/${companyId}`),
  bulkAssign: (id, companyIds, agentId) =>
    apiClient.post(`/target-lists/${id}/members/bulk-assign`, {
      company_ids: companyIds,
      agent_id: agentId,
    }),
  bulkRemove: (id, companyIds) =>
    apiClient.post(`/target-lists/${id}/members/bulk-remove`, {
      company_ids: companyIds,
    }),

  assign: (id, agentId, onlyUnassigned = false) =>
    apiClient.post(`/target-lists/${id}/assign`, {
      agent_id: agentId,
      only_unassigned: onlyUnassigned,
    }),

  dashboard: (id) => apiClient.get(`/target-lists/${id}/dashboard`),

  importFile: (id, file, createMissing = true) => {
    const form = new FormData();
    form.append("file", file);
    form.append("create_missing", String(createMissing));
    return apiClient.post(`/target-lists/${id}/import`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  forCompany: (companyId) => apiClient.get(`/target-lists/by-company/${companyId}`),
};

export const STATUS_OPTIONS = [
  { value: "active", label: "Aktivna", color: "bg-emerald-100 text-emerald-700" },
  { value: "paused", label: "Pauzirana", color: "bg-amber-100 text-amber-700" },
  { value: "completed", label: "Završena", color: "bg-blue-100 text-blue-700" },
  { value: "archived", label: "Arhivirana", color: "bg-gray-100 text-gray-600" },
];

export const PRIORITY_OPTIONS = [
  { value: "high", label: "Visoki", color: "bg-red-100 text-red-700" },
  { value: "medium", label: "Srednji", color: "bg-yellow-100 text-yellow-700" },
  { value: "low", label: "Niski", color: "bg-gray-100 text-gray-600" },
];

export const statusMeta = (v) => STATUS_OPTIONS.find((o) => o.value === v) || STATUS_OPTIONS[0];
export const priorityMeta = (v) => PRIORITY_OPTIONS.find((o) => o.value === v) || PRIORITY_OPTIONS[1];
